<template>
    <div>
        <navbar active_screen="favorite" />
        <a-spin :tip="$t('Loading...')" :spinning="getting_data">
            <div class="ml-20 mr-20 mb-20">
                <template v-if="ine(favorites)">
                    <template v-if="$device == 'mobile'">
                        <div class="mb-16 br-20" style="background-color: #ffffff; width: 100%; padding-top: 0" v-for="(favorite, favorite_index) in favorites" :key="favorite_index">
                            <div>
                                <div style="width: 50%; display: inline-block">
                                    <img :src="favorite.image" style="width: 100%; margin: 0; vertical-align: unset; border-radius: 20px 0 0 0" />
                                </div>
                                <div style="width: 50%; display: inline-block; padding-left: 8px; vertical-align: top; padding: 8px">
                                    <label class="custom-title fs-20">
                                        {{ favorite.title }}
                                    </label>
                                    <a-button size="large" class="mb-16 text-center primary-btn ant-button-label-custom ดูรายละเอียด" style="margin-left: 16px" @click="viewDetail(favorite)">
                                        <strong class="fs-18">รายละเอียด</strong>
                                    </a-button>
                                    <img @click="toggleFavorite(favorite)" src="/resources/images/icon-star-select.png" style="width: 20px; height: 20px; float: right; margin-top: 11%" />
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="row" style="padding: 0 32px 8px 32px" :style="{ 'padding-top': rowIndex > 0 ? '0' : '8px' }" v-for="(row, rowIndex) in favorites_2d" :key="'row_' + rowIndex">
                            <div class="col-4" style="padding: 8px; padding-top: 0" v-for="(favorite, favoriteIndex) in row" :key="'col_' + favoriteIndex">
                                <img :src="favorite.image" style="width: 100%; margin: 0; vertical-align: unset" @click="viewDetail(favorite)" />
                                <div style="background-color: #fff; position: relative; justify-conten: space-between; display: inline-block; width: 100%; min-height: 130px">
                                    <!-- <div class="col-11" style="padding: 0; margin: 8px 0 0 16px" @click="viewDetail(favorite)"> -->
                                    <label class="title fs-20">
                                        {{ favorite.title }}
                                    </label>
                                    <!-- </div> -->
                                    <!-- <div class="col-1"> -->
                                    <img @click="toggleFavorite(favorite)" src="/resources/images/icon-star-select.png" style="width: 20px; height: 20px; float: right; margin-top: 4px; display: inline-block" />
                                    <!-- </div> -->
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
                <div v-else class="text-center" style="display: flex; height: 100vh; justify-content: center; padding-bottom: 120px">
                    <div style="margin: auto 0; position: relative; padding: 16px; border-radius: 1rem">
                        <label class="data-not-found-label"> ยังไม่มีรายการ Favorite ในขณะนี้ </label>
                    </div>
                </div>
            </div>
        </a-spin>
        <div v-if="$device != 'mobile'" class="copyright-section-space"></div>
        <div v-if="$device != 'mobile'" class="copyright-section">© Copyright SCG Debenture Club. All Rights Reserved.</div>
    </div>
</template>
<script>
import navbar from '../../components/navbar';
export default {
    components: {
        navbar,
    },
    data: function () {
        return {
            getting_data: true,
            current_page: 1,
            last_page: 0,
            favorites: [],
            favorites_2d: [],
        };
    },
    mounted() {
        this.getFavorite(() => (this.getting_data = false));
    },
    methods: {
        getFavorite: function (callback = null, current_page = null) {
            if (typeof current_page != 'number') current_page = this.current_page;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/favorite/index',
                    data: {
                        page: current_page,
                        per_page: 20,
                    },
                    callback: (res) => {
                        if (res && res.data) {
                            this.last_page = res.last_page;
                            res.data.forEach((v) => {
                                var check_dup = this.favorites.filter((v1) => v1.xid == v.xid && v1.type == v.type);
                                if (check_dup.length == 0) {
                                    this.favorites.push(v);
                                } else {
                                    this.favorites = res.data;
                                }
                            });
                            if (res.data.length == 0) {
                                this.favorites = [];
                            }
                            this.favorites_2d = this.atg(this.favorites, 3);
                            if (typeof callback == 'function') callback();
                        } else if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        toggleFavorite(favorite) {
            var url = '/api/favorite/delete';
            this.getting_data = true;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: url,
                    data: {
                        xid: favorite.xid,
                        type: favorite.type,
                    },
                    callback: (res) => {
                        if (res && res.result == 'complete') {
                            const complete = {
                                message: '',
                            };
                            for (const [key, value] of Object.entries(res.complete)) {
                                if (key) {
                                    complete.message += value[0];
                                }
                            }
                            this.$confirm({
                                message: complete.message,
                                button: {
                                    yes: 'ปิดหน้าต่าง',
                                },
                                callback: (confirm) => {
                                    if (confirm) {
                                        this.getFavorite();
                                    }
                                },
                            });
                        } else {
                            const errors = {
                                message: '',
                            };
                            for (const [key, value] of Object.entries(res.errors)) {
                                if (key) {
                                    errors.message += value[0];
                                }
                            }
                            this.$confirm({
                                message: errors.message,
                                button: {
                                    yes: 'ปิดหน้าต่าง',
                                },
                                callback: (confirm) => {},
                            });
                        }
                        this.getting_data = false;
                    },
                },
            });
        },
        viewDetail(favorite) {
            var param = {
                back_path: '/favorite',
            };
            var route_name = '';
            if (favorite.type == 'news') {
                param.inbox_id = favorite.xid;
                route_name = '/inbox-detail';
            } else if (favorite.type == 'delight') {
                param.delight_id = favorite.xid;
                route_name = '/delight-detail';
            } else if (favorite.type == 'privilege') {
                param.priv_id = favorite.xid;
                route_name = '/privilege-detail';
            } else if (favorite.type == 'activity') {
                param.act_id = favorite.xid;
                route_name = '/activity-detail';
            } else if (favorite.type == 'reward') {
                param.priv_id = favorite.xid;
                route_name = '/reward-condition';
            }
            return this.r(route_name, param);
            // this.r()
        },
    },
};
</script>
<style scoped>
img {
    float: left;
}
.custom-title {
    color: #cc0000 !important;
    font-weight: 600 !important;
    /* margin: 8px 0 0 16px; */
    margin: 0px 16px 0 16px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 32px;
    /* display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis; */
}
.ดูรายละเอียด {
    border-radius: 0;
    min-width: 92px;
    height: 32px;
    margin: 0;
    margin-top: 8px;
}
</style>
